import apiClient from './client';

export type PrivacyPolicyContentItem = {
  title: string;
  items: string[];
};

export type PrivacyPolicyPayload = {
  title: string;
  description: string;
  content: PrivacyPolicyContentItem[];
};

export type PrivacyPolicyResponse = PrivacyPolicyPayload & {
  id: number | null;
  updatedAt?: string | null;
};

export interface MessageResponse {
  message: string;
  data?: PrivacyPolicyResponse;
}

export const privacyPolicyApi = {
  get: async (): Promise<PrivacyPolicyResponse> => {
    const response = await apiClient.get('/api/privacy-policy');
    return response.data;
  },

  create: async (data: PrivacyPolicyPayload): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/privacy-policy', data);
    return response.data;
  },

  update: async (data: PrivacyPolicyPayload): Promise<MessageResponse> => {
    const response = await apiClient.put('/api/privacy-policy', data);
    return response.data;
  },

  delete: async (): Promise<MessageResponse> => {
    const response = await apiClient.delete('/api/privacy-policy');
    return response.data;
  },
};